import "core-js/modules/es.array.concat.js";
import { getReq, postReq, putReq } from './axios';
import { officeBody } from './models';
var BASE_URL = "".concat(apiUrl, "/office");
export var getAllOffices = function getAllOffices() {
  return getReq(BASE_URL);
};
export var getOffice = function getOffice(id) {
  return getReq("".concat(BASE_URL, "/").concat(id));
};
export var createOffice = function createOffice(body) {
  return postReq(BASE_URL, officeBody(body));
};
export var updateOffice = function updateOffice(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), officeBody(body));
};